"use client";

import {
  AnalyticsProvider,
  PageTracker,
} from "@areahub/adapters/src/analytics/analytics.client";
import { GeoLocationProvider } from "@areahub/ui/components/search/contexts";
import { LoadingArea } from "@ui/loading";
import { Suspense, type FC, type PropsWithChildren } from "react";
import { Provider as JotaiProvider } from "jotai";
import ChakraProvider from "./chakra";
import { ClientProvider } from "./trpc";

const Providers: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ClientProvider>
      <ChakraProvider>
        <JotaiProvider>
          <AnalyticsProvider writeKey={process.env.SEGMENT_WRITE_KEY as string}>
            <Suspense fallback={<LoadingArea h="100vh" w="full" />}>
              <PageTracker />
            </Suspense>
            <GeoLocationProvider>{children}</GeoLocationProvider>
          </AnalyticsProvider>
        </JotaiProvider>
      </ChakraProvider>
    </ClientProvider>
  );
};

export default Providers;
